import { getElement, getElements, ifSelectorExist } from "./utils";

export const TeamBlockModal = () => {
    const attorneyItems = getElements('.team-item');
    const modalWindow = getElement('.team-modal-window');

    const openModalWindow = (attorneyItem) => {
        // Information from Attorney Items
        const attorneyiItemName = attorneyItem.querySelector('h4').textContent;
        const attorneyiItemDescription = attorneyItem.querySelector('.description').textContent;
        const attorneyiItemPosition = attorneyItem.querySelector('.position').textContent;
        const attorneyiItemImage = attorneyItem.querySelector('img').getAttribute('src');
        const attorneyiItemImageClasses = attorneyItem.querySelector('img').getAttribute('class');

        // Put information in Modal Window
        const modalWindowAttorneyName = getElement('.team-modal-name').textContent = attorneyiItemName;
        const modalWindowAttorneyDescription = getElement('.team-modal-description').textContent = attorneyiItemDescription;
        const modalWindowAttorneyPosition = getElement('.team-modal-position').textContent = attorneyiItemPosition;
        const modalAttorneyImage = getElement('.team-modal-window img');
        modalAttorneyImage.setAttribute('src', attorneyiItemImage);
        modalAttorneyImage.setAttribute('srcset', attorneyiItemImage);
        modalAttorneyImage.setAttribute('class', attorneyiItemImageClasses);
        modalWindow.classList.add('block');
        document.body.style.overflow = 'hidden';
    }

    const closeModalWindow = () => {
        modalWindow.classList.add('fade-out');
        document.body.style.overflow = null;
        setTimeout(() => {
            modalWindow.classList.remove('block', 'fade-out');
            document.body.style.overflow = null;
        }, 300);
    }

    if (ifSelectorExist(attorneyItems)) {
        attorneyItems.forEach(attorneyItem => {
            attorneyItem.addEventListener('click', () => {
                openModalWindow(attorneyItem);
            });
        });
    }

    const btnClose = getElement('.team-modal-window-close');
    if (ifSelectorExist(btnClose)) {
        btnClose.addEventListener('click', () => {
            closeModalWindow();
        })
    }

    const modalWindowWrapper = getElement('.team-modal-window');
    if (ifSelectorExist(modalWindowWrapper)) {
        modalWindowWrapper.addEventListener('click', (e) => {
            if (e.target === modalWindowWrapper) {
                closeModalWindow();
            }
        })
    }
}